import Serv156Service from '@/services/Serv156Service'

export const servicos156 = {
  namespaced: true,
  actions: {
    buscarTopAssuntosDemandados ({ dispatch },{intervalo, top , ordenacao }) {
      return Serv156Service.buscarTopAssuntosDemandados({ intervalo, top, ordenacao })
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },
    buscarTopPorRegiao ({ dispatch }, { topReqs, intervalo, ordenacao, filtroId}) {
      // commit('loginRequest', { username, manter });
      return Serv156Service.buscarTopServicosRegiao({ topReqs, intervalo, ordenacao, filtroId })
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },
    buscarTopPorOrgao ({ dispatch }, { topReqs, intervalo, ordenacao, filtroId }) {
      // commit('loginRequest', { username, manter });
      return Serv156Service.buscarTopServicosOrgao({ topReqs, intervalo, ordenacao, filtroId })
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },
    buscarTopServicosDemandados ({ dispatch }, { topReqs, intervalo }) {
      // commit('loginRequest', { username, manter });
      return Serv156Service.buscarTopServicosDemandados({ topReqs, intervalo })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarTopServicosConsolidados ({ dispatch }, { topReqs, intervalo, ordenacao }) {
      return Serv156Service.buscarTopServicosConsolidados({ topReqs, intervalo, ordenacao })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarSolicitacoesConsolidadoPorOrgao ({ dispatch }, { intervalo }) {
      return Serv156Service.buscarSolicitacoesConsolidadoPorOrgao({ intervalo })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarSolicitacoesPorCanal ({ dispatch }) {
      // commit('loginRequest', { username, manter });
      return Serv156Service.buscarSolicitacoesPorCanal()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarSolicitacoesConsolidado ({ dispatch }) {
      return Serv156Service.buscarSolicitacoesConsolidado()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarEvolucaoEstoqueSolicitacao ({ dispatch }, {agrupamento}) {
      return Serv156Service.buscarEvolucaoEstoqueSolicitacao({agrupamento})
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarTopTemasDemandados ({ dispatch },{intervalo, top , ordenacao }) {
      return Serv156Service.buscarTopTemasDemandados({ intervalo, top, ordenacao })
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },
    buscarNaoGeorreferenciados ({ dispatch },{intervalo, top , ordenacao }) {
      return Serv156Service.buscarServicosNaoGeorreferenciados({ intervalo })
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },

  },

  state: {},
  mutations: {},
}
